import { render, staticRenderFns } from "./aiKoutu.vue?vue&type=template&id=01571d0c&scoped=true"
import script from "./aiKoutu.vue?vue&type=script&lang=js"
export * from "./aiKoutu.vue?vue&type=script&lang=js"
import style0 from "./aiKoutu.vue?vue&type=style&index=0&id=01571d0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01571d0c",
  null
  
)

export default component.exports